import { SearchCriteria } from "./search-criteria";

export class GetBookingsForDownPaymentCriteria extends SearchCriteria {
  public ClientId: number;
  public BookingId: number;
}
